import { useEffect, useRef, useState } from 'react';
import { recuperarTranscricaoRascunhoAtivo } from '../../../../../services/TranscricaoBeneficiarioService';
import { useTranscricao } from '../context';
import { TranscricaoStepEnum } from '../types';

export const useRascunhoAtivo = () => {
  const { dispatch } = useTranscricao();
  const [showModalRascunhoAtivo, setShowModalRascunhoAtivo] = useState(false);
  const [verificandoRascunhoAtivo, setVerificandoRascunhoAtivo] = useState(true);
  const rascunhoAtivoIdRef = useRef<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const validarRascunhoAtivo = async () => {
      setVerificandoRascunhoAtivo(true);
      try {
        const idTranscricaoRascunho = await recuperarTranscricaoRascunhoAtivo();
        if (cancelled || !idTranscricaoRascunho) return;

        rascunhoAtivoIdRef.current = idTranscricaoRascunho;
        setShowModalRascunhoAtivo(true);
      } finally {
        if (!cancelled) {
          setVerificandoRascunhoAtivo(false);
        }
      }
    };

    void validarRascunhoAtivo();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleRecusarRascunhoAtivo = () => {
    rascunhoAtivoIdRef.current = null;
    dispatch({ type: 'RESET' });
    setShowModalRascunhoAtivo(false);
  };

  const handleContinuarRascunhoAtivo = () => {
    const idTranscricao = rascunhoAtivoIdRef.current;
    if (!idTranscricao) {
      setShowModalRascunhoAtivo(false);
      return;
    }

    dispatch({ type: 'RESET' });
    dispatch({ type: 'SET_ID_TRANSCRICAO', payload: idTranscricao });
    dispatch({ type: 'SET_TERMOS_ACEITOS', payload: true });
    dispatch({ type: 'SET_STEP', payload: TranscricaoStepEnum.Transcricao });
    dispatch({ type: 'SET_REVISAO_STATUS', payload: 'carregando' });
    dispatch({ type: 'SET_ORIGEM_REVISAO', payload: 'continuarRascunho' });
    setShowModalRascunhoAtivo(false);
  };

  return {
    verificandoRascunhoAtivo,
    showModalRascunhoAtivo,
    handleRecusarRascunhoAtivo,
    handleContinuarRascunhoAtivo,
  };
};
